<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="attachmentListData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="operations">
        <span @click="doDelete(index)">
          <!-- 下载 -->
          <Button
            type="success"
            size="small"
            v-hasPermission="[
              'operationKpiConfigurationManagement:overtimeManagement:download'
            ]"
            @click="downloadModal = true"
            style="margin-right: 5px;"
            >{{ $t("ticket.comment.download") }}</Button
          >
          <!-- 删除 -->
          <Button
            type="error"
            size="small"
            v-hasPermission="[
              'operationKpiConfigurationManagement:overtimeManagement:delete'
            ]"
            @click="attachmentListDelmodal = true"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 下载附件模式框 -->
    <Modal v-model="downloadModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("ticket.list.affirmDownload") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{
            $t("ticket.comment.confirmDownload") +
              fileName +
              $t("ticket.comment.what")
          }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="success"
          size="large"
          long
          :loading="modal_loadings"
          @click="downloadFile()"
          :disabled="isDisable"
          >{{ $t("ticket.comment.download") }}
        </Button>
      </div>
    </Modal>
    <!-- 删除 -->
    <Modal v-model="attachmentListDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{
            $t("alarms.common.sureDelete") +
              fileName +
              $t("ticket.comment.what")
          }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAttachmentList()"
          :disabled="isDisables"
          >{{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import utils from "../../../../utils/utils.js";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

var tableAttachmentListVue = {};
export default {
  name: "TableAttachmentList",
  data() {
    return {
      downloadModal: false,
      isDisable: false,
      modal_loadings: false, //下载
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      startDate: "", //分页
      attachmentListDelmodal: false,
      modal_loading: false,
      isDisables: false,
      fileName: "", //删除
      columns: [
        {
          title: this.$t("MCM.extraContributionManagement.filename"),
          key: "fileName"
        },
        {
          title: this.$t("MCM.extraContributionManagement.fileType"),
          key: "fileType"
        },
        {
          title: this.$t("MCM.extraContributionManagement.saveAddress"),
          key: "storagePath"
        },
        {
          title: this.$t(
            "MCM.extraContributionManagement.extraContributionDate"
          ),
          key: "overtimeYearMonth"
        },
        {
          title: this.$t("MCM.extraContributionManagement.description"),
          key: "remark"
        },
        {
          title: this.$t("MCM.extraContributionManagement.operation"),
          slot: "operations"
        }
      ],
      attachmentListData: []
    };
  },
  beforeCreate: function() {
    tableAttachmentListVue = this;
  },
  mounted: function() {
    tableAttachmentListVue.getAttachmentListData();
  },
  methods: {
    showAll: function() {
      tableAttachmentListVue.getAttachmentListData();
    },
    // 分页显示数据
    getAttachmentListData: function() {
      eventBus.$on("startDate", function(startDate) {
        tableAttachmentListVue.startDate = startDate;
      });
      // 列表分页
      this.$api.kpiOvertimeRecordByYearMonth
        .pageKpiOvertimeRecordByYearMonth({
          overtimeYearMonth: tableAttachmentListVue.startDate,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.attachmentListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAttachmentListVue.getAttachmentListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAttachmentListVue.getAttachmentListData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("startDate");
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
      this.fileName = this.attachmentListData[index].fileName;
    },
    removeAttachmentList: function() {
      this.isDisables = true;
      var lineIndex = this.lineIndex;
      // 删除
      this.$api.kpiOvertimeRecordByYearMonth
        .deleteSingleAttatchment({
          id: this.attachmentListData[lineIndex].id,
          attatchmentId: this.attachmentListData[lineIndex].attatchmentId
        })
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableAttachmentListVue.getAttachmentListData();
            this.isDisables = false;
            this.modal_loading = false;
            this.attachmentListDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 下载附件
    /************************************************************/
    downloadFile: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      // 下载附件
      this.$api.file
        .downloadFile("id", this.attachmentListData[lineIndex].attatchmentId)
        .then(res => {
          let aTag = document.createElement("a");
          let blob = new Blob([res.data], { type: "text/plain;charset=UTF-8" });
          aTag.download = this.attachmentListData[lineIndex].fileName; // 下载的文件名
          aTag.href = URL.createObjectURL(blob);
          aTag.click();
          URL.revokeObjectURL(blob);
          this.modal_loadings = true;
          setTimeout(() => {
            this.isDisable = false;
            this.modal_loadings = false;
            this.downloadModal = false;
            this.$Message.success(this.$t("common.downloadSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/overtime_management/TableAttachmentList.vue